import useProfile from './useProfileV2';

const useHasPermission = (permission: string): boolean => {
  const { profile } = useProfile();

  for (let i = 0; i < profile.roles.length; i += 1) {
    for (let j = 0; j < profile.roles[i].permissions.length; j += 1) {
      if (profile.roles[i].permissions[j].value === permission) {
        return true;
      }
    }
  }

  return false;
};

export default useHasPermission;
